function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgNewsAndMedia = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 38 34",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    xmlnsSerif: "http://www.serif.com/",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M7.272,4.651C7.272,2.124 9.327,0.07 11.854,0.07L32.47,0.07C34.997,0.07 37.051,2.124 37.051,4.651L37.051,27.558C37.051,30.085 34.997,32.14 32.47,32.14L6.127,32.14C2.963,32.14 0.4,29.577 0.4,26.413L0.4,6.942C0.4,5.675 1.424,4.651 2.691,4.651C3.958,4.651 4.981,5.675 4.981,6.942L4.981,26.413C4.981,27.043 5.497,27.558 6.127,27.558C6.757,27.558 7.272,27.043 7.272,26.413L7.272,4.651ZM11.854,6.369L11.854,12.096C11.854,13.048 12.619,13.814 13.572,13.814L30.752,13.814C31.704,13.814 32.47,13.048 32.47,12.096L32.47,6.369C32.47,5.417 31.704,4.651 30.752,4.651L13.572,4.651C12.619,4.651 11.854,5.417 11.854,6.369ZM11.854,19.541C11.854,20.171 12.369,20.686 12.999,20.686L19.871,20.686C20.501,20.686 21.016,20.171 21.016,19.541C21.016,18.911 20.501,18.395 19.871,18.395L12.999,18.395C12.369,18.395 11.854,18.911 11.854,19.541ZM23.307,19.541C23.307,20.171 23.822,20.686 24.452,20.686L31.324,20.686C31.954,20.686 32.47,20.171 32.47,19.541C32.47,18.911 31.954,18.395 31.324,18.395L24.452,18.395C23.822,18.395 23.307,18.911 23.307,19.541ZM11.854,26.413C11.854,27.043 12.369,27.558 12.999,27.558L19.871,27.558C20.501,27.558 21.016,27.043 21.016,26.413C21.016,25.783 20.501,25.267 19.871,25.267L12.999,25.267C12.369,25.267 11.854,25.783 11.854,26.413ZM23.307,26.413C23.307,27.043 23.822,27.558 24.452,27.558L31.324,27.558C31.954,27.558 32.47,27.043 32.47,26.413C32.47,25.783 31.954,25.267 31.324,25.267L24.452,25.267C23.822,25.267 23.307,25.783 23.307,26.413Z",
    style: {
      fill: "rgb(0,101,157)",
      fillRule: "nonzero"
    }
  }));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgNewsAndMedia);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/news-and-media.45b0bcb2a8b26ee05565ed7ea8ab8ddc.svg";